<template>
  <div
    class="lv-checklist-collapse"
  >
    <div
      class="lv-checklist-collapse__title-wrap"
      @click="$_onToggleCollapse()"
    >
      <div class="name">
        <img
          :src="item.title.icon"
          class="leading-icon mr-3"
        >
        <LvText
          h4
          bold
          noWrap
        >
          {{ $t(item.title.name) }}
        </LvText>
      </div>  
      <div class="risk-icons">
        <LvRiskIcon
          v-for="(risk, riskIndex) in item.riskIconList"
          :key="riskIndex"
          :color="risk.color"
          :leading-icon="risk.icon"
          :num="risk.num"
          :backgroundColor="risk.backgroundColor"
        />
      </div>
      <div
        v-if="item.remarkList"
        class="text-content"
      >
        <div
          v-for="(remark, remarkIndex) in item.remarkList"
          :key="remarkIndex"
          class="text"
        >
          <LvText h6 :red="remark.color === 'red'">
            {{ $t(remark.text) }}
          </LvText>
          <span>{{remarkIndex === item.remarkList.length -1 ? '': '/'}}</span>
        </div>
        <LvText h6><i class="icon-info icon" /></LvText>
        <div class="tooltips">
          {{ $t('請注意"已完成數量"包含了排程作業和臨時性點檢作業，因此有可能超出原先排程設定的共應完成總筆數。') }}
        </div>
      </div>

      <i
        v-if="isActive.collapse"
        class="icon-unfold-less trailing-icon"
      />
      <i
        v-else
        class="icon-unfold-more trailing-icon"
      />
    </div>
    <slide-up-down
      :active="isActive.collapse"
      :duration="100"
      class="lv-checklist-collapse__collapse"
    >
      <div v-if="isFetched">  
        <div
          v-for="(field, fieldIndex) in item.collapseFields"
          :key="fieldIndex"
        >
          <LvDataTable
            v-if="field.isShow"
            hideEmptyPic
            :label="field.label"
            :disable="field.disable"
            :titleSize="field.titleSize"
            :fetchUrl="field.fetchUrl"
            :setTitle="field.setTitle"
            :setParams="field.setParams"
            :setListData="field.setListData"
            :columnHeader="field.columnHeader"
            class="mb-10"
            @click-btn="$emit('click-btn', $event)"
            @click-item="$emit('click-item', $event)"
            @menu-item-click="$emit('click-download', $event)"
            @fetch-data="$_checkIsHaveDataList($event, fieldIndex)"
          />
        </div>
      </div>
    </slide-up-down>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isFetched: false,
      isActive: {
        collapse: false,
      },
    };
  },
  methods: {
    $_onToggleCollapse() {
      this.isActive.collapse = !this.isActive.collapse;
      if ( this.isActive.collapse && !this.isFetched ) {
        this.isFetched = true;
      }
    },
    $_checkIsHaveDataList(dataList, fieldIndex) {
      this.item.collapseFields[fieldIndex].isShow= dataList.length > 0;
    }
  },
};
</script>